module.exports = __webpack_public_path__ + "static/media/w_b_45.538b0936.png";